import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/** Placeholder buttons of the toolbar while the document loads. */
const TOOLBAR_SKELETON = Array.from({ length: 14 }, (_unused, index) => `tool-${index}`);

/**
 * The Word viewer's bars and a page, while the document loads. Has no dependency on the editor engine: it shows
 * while that loads.
 */
export function DocxViewerSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("flex h-full min-h-0 flex-col bg-background", className)}>
      <div className="flex h-11 shrink-0 items-center gap-3 border-b px-3">
        <Skeleton className="size-7 rounded-md" />
        <Skeleton className="h-4 w-24" />
        <Skeleton className="ms-auto h-6 w-28 rounded-md" />
      </div>
      <div className="flex h-11 shrink-0 items-center gap-1.5 border-b px-3">
        {TOOLBAR_SKELETON.map((id) => (
          <Skeleton key={id} className="size-7 rounded-md" />
        ))}
      </div>
      <div className="flex min-h-0 flex-1 justify-center overflow-hidden bg-muted pt-8">
        <Skeleton className="aspect-[1/1.414] w-full max-w-3xl rounded-xs" />
      </div>
    </div>
  );
}
